export const isUpdatedSelector = (state) => state.sendTicket.isUpdated;
export const isLoadingSelector = (state) => state.sendTicket.isLoading;
export const errorSelector = (state) => {
    return {
        error: state.sendTicket.error,
        errorMessage: state.sendTicket.errorMessage
    };
};
export const userEmailSelector = (state) => state.user.status.email;
//# sourceMappingURL=selectors.js.map